export default "__VITE_ASSET__Df$p9P$O__"